import { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'
import { EgowallLogo } from '@/features/album/components/EgowallLogo'
import AuthAside from './AuthAside'

const Root = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  background: 'var(--ds-canvas, #fff)',
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr',
  },
}))

const FormSide = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
})

const LogoRow = styled(Box)({
  padding: '28px 40px 0',
})

const FormSlot = styled(Box)({
  flex: 1,
  minHeight: 0,
  display: 'flex',
})

const AsideCol = styled(Box)(({ theme }) => ({
  display: 'flex',
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}))

/**
 * Full-page (non-modal) auth shell — a split layout (form column +
 * living-album aside), unlike `AuthDialog` which presents the same forms
 * inside a MUI `Dialog`. Wraps the existing `Login` / `SignUp` /
 * `ForgotPassword` flows unchanged; only the chrome around them differs.
 */
export default function AuthPageLayout({ children }: { children: ReactNode }) {
  const navigate = useNavigate()

  return (
    <Root>
      <FormSide>
        <LogoRow>
          <EgowallLogo onClick={() => navigate('/')} />
        </LogoRow>
        <FormSlot>{children}</FormSlot>
      </FormSide>
      <AsideCol>
        <AuthAside />
      </AsideCol>
    </Root>
  )
}
